export default function rem(size) {
  const remSize = parseFloat(size.replace('px', '')) / 16

  return `${remSize}rem`
}



// WEBPACK FOOTER //
// ./src/styles/tools/rem.js